/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_APPROVAL_HISTORY_REQUEST,
  FETCH_APPROVAL_HISTORY_SUCCESS,
  FETCH_APPROVAL_HISTORY_FAILURE,
} from "./ApprovalHistoryTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchApprovalHistoryRequest = () => {
  return {
    type: FETCH_APPROVAL_HISTORY_REQUEST,
  };
};

export const fetchApprovalHistorySuccess = (approvalLogs) => {
  return {
    type: FETCH_APPROVAL_HISTORY_SUCCESS,
    payload: approvalLogs,
  };
};

export const fetchApprovalHistoryFailure = (error) => {
  return {
    type: FETCH_APPROVAL_HISTORY_FAILURE,
    payload: error,
  };
};

export const fetchApprovalHistoryDetails = (portfolioId,contentID) => {
  return async function (dispatch) {
    dispatch(fetchApprovalHistoryRequest());
    try {
      const data = await APIManager.getApprovalHistoryData(portfolioId, contentID);
      dispatch(fetchApprovalHistorySuccess(data));
    } catch (error) {
      dispatch(fetchApprovalHistoryFailure(error));
      dispatch(commonError(error, FETCH_APPROVAL_HISTORY_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
